// JavaScript code for acf_blocks/programmes-comparison-table component
(($) => {

    "use strict";
    if (!$('.acf-blocks-programmes-comparison-table').length) {
        return;
    }
    console.log("acf_blocks/programmes-comparison-table scripts loaded...");

    /**
     * Load the comparison list table on page load based on IDs stored in localStorage.
     * If no IDs are stored, the table will not be displayed.
     */
    loadComparisonListTable();

    /**
     * Handle the change event on the select dropdown to add a programme to the comparison list.
     * Prevent adding duplicates and update the comparison list in localStorage.
     */
    $('.comparison-grid').on('change', 'select', function () {
        let selectedId = parseInt($(this).val());
        let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
        if (compareList.some((item) => item.id === selectedId)) {
            alert('This programme is already in the comparison list.');
            $(this).val('');
            return;
        }
        compareList.push({id: selectedId});
        localStorage.setItem('compareList', JSON.stringify(compareList));
        loadComparisonListTable();
    });

    /**
     * Load and display the comparison list table based on IDs stored in localStorage.
     */
    function loadComparisonListTable() {
        let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
        if (!compareList.length) {
            return;
        }
        let learnMoreText = $('.comparison-grid').data('learn-more-text') || 'Learn More';
        let learnMoreUrl = $('.comparison-grid').data('learn-more-url') || '';
        let programmes_ids = compareList.map(item => item.id).join(',');
        var url = new URL(window.location.href.split('?')[0]);
        url.searchParams.set('snaction', 'get_programmes_for_comparison');
        url.searchParams.set('compare_ids', programmes_ids);
        $.ajax({
            url: url.toString(),
            method: 'GET',
            dataType: 'json',
            cache: false,
            beforeSend: function () {
                $('.comparison-grid select').prop('disabled', true);
            },
            success: function (response) {
                if (!response.success) {
                    return;
                }

                let programmesList = response.data || [];
                if (!programmesList.length) {
                    return;
                }

                // update compareList in localStorage to keep only valid programmes infos
                compareList = programmesList.map(item => ({id: item.id, title: item.title, thumbnail: item.thumbnail}));
                localStorage.setItem('compareList', JSON.stringify(compareList));

                const orderOfFieldIds = $('.comparison-grid [data-field-id]').map(function () {
                    return $(this).data('field-id');
                }).get();

                for (let i = 0; i < programmesList.length; i++) {
                    let programme = programmesList[i];
                    $('.comparison-grid .logo-placeholder').eq(i).find('div').html(
                        programme.logo ? `
                            <a href="${programme.permalink}">
                                <img class="inline-block max-w-[90%] h-auto" src="${programme.logo}" alt="${programme.title} Logo">
                            </a>
                        ` : 'No Logo'
                    );
                    $('.comparison-grid .logo-placeholder').eq(i).find('select').addClass('hidden');
                    $('.comparison-grid .permalink-placeholder').eq(i).html(
                        programme.permalink ? `
                            <a href="${learnMoreUrl || programme.permalink}" class="btn-goldenSun group">
                                ${learnMoreText}
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                                  <path class="group-hover:stroke-white group-hover:fill-white" d="M10.374 0.800781C10.4711 0.805262 10.5664 0.83042 10.6533 0.874023C10.7346 0.914849 10.8066 0.971491 10.8662 1.04004L15.291 5.51562C15.3575 5.58034 15.4103 5.65859 15.4463 5.74414C15.4821 5.82948 15.5009 5.9211 15.501 6.01367C15.501 6.10643 15.4822 6.19868 15.4463 6.28418C15.4108 6.3686 15.3582 6.4446 15.293 6.50879L15.2939 6.50977L10.8613 10.9932C10.7969 11.0586 10.7204 11.1109 10.6357 11.1465C10.5511 11.182 10.46 11.2002 10.3682 11.2002C10.2764 11.2002 10.1852 11.182 10.1006 11.1465C10.016 11.1109 9.93942 11.0585 9.875 10.9932L9.87207 10.9902C9.74662 10.8573 9.67677 10.6809 9.67676 10.498C9.67676 10.3152 9.74661 10.1388 9.87207 10.0059L9.875 10.0029L13.1211 6.72363H1.7627C1.5834 6.71394 1.41492 6.63488 1.29199 6.50391C1.16915 6.37288 1.10071 6.19921 1.10059 6.01953C1.10059 5.83969 1.16905 5.66532 1.29199 5.53418C1.41492 5.40321 1.58341 5.32414 1.7627 5.31445H13.1221L9.88086 2.03125H9.87988C9.81197 1.97076 9.75691 1.89724 9.7168 1.81543C9.67392 1.72798 9.64888 1.63249 9.64453 1.53516C9.64022 1.43791 9.65655 1.34087 9.69141 1.25C9.72629 1.15905 9.77921 1.07607 9.84766 1.00684C9.91611 0.937592 9.99828 0.883213 10.0889 0.847656C10.1794 0.812113 10.2768 0.796339 10.374 0.800781Z" fill="black" stroke="black" stroke-width="0.4"/>
                                </svg>
                            </a>
                        ` : ''
                    );
                    for (let field of orderOfFieldIds) {
                        if (field === 'group_size') {
                            let count = programme.group_size <= 12 ? programme.group_size : 12;
                            if (!count) {
                                $(`.comparison-grid .row-content-${field}`).eq(i).html('–');
                                continue;
                            }
                            let icons = `
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                  <path d="M18.6894 16.4698C17.0604 13.1937 13.6909 10.944 9.80083 10.944C5.90862 10.944 2.5407 13.1937 0.912148 16.4699C0.562755 17.1728 1.07851 18 1.86007 18H17.7415C18.5231 18 19.0389 17.1726 18.6894 16.4698Z" fill="black"/>
                                  <path d="M11.7241 9.72226C14.2885 8.65436 15.5062 5.69864 14.444 3.12049C13.3818 0.542335 10.4419 -0.681963 7.87756 0.385942C5.31319 1.45385 4.09544 4.40956 5.15763 6.98771C6.21982 9.56587 9.15973 10.7902 11.7241 9.72226Z" fill="black"/>
                                </svg>
                            `.repeat(count);
                            $(`.comparison-grid .row-content-${field}`).eq(i).html(
                                `<div class="inline-grid grid-cols-4 gap-[2px]">${icons}</div> 
                                 <span class="block mt-[10px]">${programme.group_size_text}</span>`
                            );
                        } else if (field === 'available_as') {
                            let items = programme.available_as || [];
                            if (!items.length) {
                                $(`.comparison-grid .row-content-${field}`).eq(i).html('–');
                                continue;
                            }

                            if (items.length > 1) {
                                let text = items.map((item, i) => item.label).join(' or ');
                                $(`.comparison-grid .row-content-${field}`).eq(i).html(`
                                    <svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18" fill="none">
                                      <path d="M3.75 7.75C5.13071 7.75 6.25 6.63071 6.25 5.25C6.25 3.86929 5.13071 2.75 3.75 2.75C2.36929 2.75 1.25 3.86929 1.25 5.25C1.25129 6.63018 2.36982 7.74871 3.75 7.75ZM22.5 9H20C19.3397 8.99928 18.7061 9.26059 18.2383 9.72656C19.8432 10.6 20.9336 12.1884 21.1719 14H23.75C24.4404 14 25 13.4404 25 12.75V11.5C24.9987 10.1198 23.8802 9.00129 22.5 9ZM2.5 9C1.11982 9.00129 0.0012921 10.1198 0 11.5V12.75C0 13.4404 0.559644 14 1.25 14H3.82422C4.06561 12.1885 5.15691 10.6009 6.76172 9.72656C6.29389 9.26059 5.66029 8.99928 5 9H2.5ZM21.25 7.75C22.6307 7.75 23.75 6.63071 23.75 5.25C23.75 3.86929 22.6307 2.75 21.25 2.75C19.8693 2.75 18.75 3.86929 18.75 5.25C18.7513 6.63018 19.8698 7.74871 21.25 7.75Z" fill="black"/>
                                      <path d="M15.5 10.25H15.1758C14.3424 10.6574 13.4276 10.871 12.5 10.875C11.5391 10.875 10.6406 10.6406 9.82422 10.25H9.5C7.01499 10.2506 5.00065 12.265 5 14.75V15.875C5 16.9105 5.83947 17.75 6.875 17.75H18.125C19.1605 17.75 20 16.9105 20 15.875V14.75C19.9994 12.265 17.985 10.2506 15.5 10.25ZM12.5 9C14.9162 9 16.875 7.04125 16.875 4.625C16.875 2.20875 14.9162 0.25 12.5 0.25C10.0838 0.25 8.125 2.20875 8.125 4.625C8.12438 5.78551 8.58511 6.89867 9.40572 7.71928C10.2263 8.53989 11.3395 9.00062 12.5 9Z" fill="black"/>
                                    </svg>
                                    <span class="inline-block ml-[10px]">${text}</span>
                                `);
                                continue;
                            }

                            let item = items[0];
                            let icon = '';
                            let text = item.label;
                            if (item.value === 'group') {
                                icon = `
                                    <svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18" fill="none">
                                      <path d="M3.75 7.75C5.13071 7.75 6.25 6.63071 6.25 5.25C6.25 3.86929 5.13071 2.75 3.75 2.75C2.36929 2.75 1.25 3.86929 1.25 5.25C1.25129 6.63018 2.36982 7.74871 3.75 7.75ZM22.5 9H20C19.3397 8.99928 18.7061 9.26059 18.2383 9.72656C19.8432 10.6 20.9336 12.1884 21.1719 14H23.75C24.4404 14 25 13.4404 25 12.75V11.5C24.9987 10.1198 23.8802 9.00129 22.5 9ZM2.5 9C1.11982 9.00129 0.0012921 10.1198 0 11.5V12.75C0 13.4404 0.559644 14 1.25 14H3.82422C4.06561 12.1885 5.15691 10.6009 6.76172 9.72656C6.29389 9.26059 5.66029 8.99928 5 9H2.5ZM21.25 7.75C22.6307 7.75 23.75 6.63071 23.75 5.25C23.75 3.86929 22.6307 2.75 21.25 2.75C19.8693 2.75 18.75 3.86929 18.75 5.25C18.7513 6.63018 19.8698 7.74871 21.25 7.75Z" fill="black"/>
                                      <path d="M15.5 10.25H15.1758C14.3424 10.6574 13.4276 10.871 12.5 10.875C11.5391 10.875 10.6406 10.6406 9.82422 10.25H9.5C7.01499 10.2506 5.00065 12.265 5 14.75V15.875C5 16.9105 5.83947 17.75 6.875 17.75H18.125C19.1605 17.75 20 16.9105 20 15.875V14.75C19.9994 12.265 17.985 10.2506 15.5 10.25ZM12.5 9C14.9162 9 16.875 7.04125 16.875 4.625C16.875 2.20875 14.9162 0.25 12.5 0.25C10.0838 0.25 8.125 2.20875 8.125 4.625C8.12438 5.78551 8.58511 6.89867 9.40572 7.71928C10.2263 8.53989 11.3395 9.00062 12.5 9Z" fill="black"/>
                                    </svg>
                                `;
                            } else {
                                icon = `
                                    <svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18" fill="none">
                                      <path d="M7.42188 9C9.3635 9 10.9375 7.426 10.9375 5.48438C10.9375 3.54275 9.3635 1.96875 7.42188 1.96875C5.48025 1.96875 3.90625 3.54275 3.90625 5.48438C3.90625 7.426 5.48025 9 7.42188 9Z" fill="black"/>
                                      <path d="M11.4258 10.9531C10.0508 10.2549 8.5332 9.97656 7.42188 9.97656C5.24512 9.97656 0.78125 11.3115 0.78125 13.9805V16.0312H8.10547V15.2466C8.10547 14.3188 8.49609 13.3887 9.17969 12.6133C9.7251 11.9941 10.4888 11.4194 11.4258 10.9531Z" fill="black"/>
                                      <path d="M16.6016 10.5625C14.0591 10.5625 8.98438 12.1328 8.98438 15.25V17.5938H24.2188V15.25C24.2188 12.1328 19.144 10.5625 16.6016 10.5625Z" fill="black"/>
                                      <path d="M16.6016 9C18.9747 9 20.8984 7.07622 20.8984 4.70312C20.8984 2.33003 18.9747 0.40625 16.6016 0.40625C14.2285 0.40625 12.3047 2.33003 12.3047 4.70312C12.3047 7.07622 14.2285 9 16.6016 9Z" fill="black"/>
                                    </svg>
                                `;
                            }

                            $(`.comparison-grid .row-content-${field}`).eq(i).html(`
                                ${icon}
                                <span class="inline-block ml-[7px]">${text}</span>
                            `);
                        } else if (field === 'delivery') {
                            let delivery_mode = programme.delivery;
                            if (!delivery_mode) {
                                $(`.comparison-grid .row-content-${field}`).eq(i).html('–');
                                continue;
                            }
                            let icon = `<img class="inline-block brightness-0 max-h-[18px] max-w-[25px]" src="${delivery_mode.icon}" alt="${delivery_mode.name} Icon">`;
                            let text = delivery_mode.name;
                            $(`.comparison-grid .row-content-${field}`).eq(i).html(`
                                ${icon}
                                <span class="inline-block ml-[7px]">${text}</span>
                            `);
                        } else {
                            $(`.comparison-grid .row-content-${field}`).eq(i).html(programme[field] || '–');
                        }
                    }
                }
            },
            complete: function () {
                $('.comparison-grid select').prop('disabled', false);
            },
            error: function () {
                alert('An error occurred while fetching comparison programmes. Please try again.');
            }
        });
    }

})(jQuery);